<template>
  <NuxtLayout name="media">
    <div class="container--MediaAlbum">
      <h1 v-text="page.title" />

      <section class="mediaAlbum__CategorySelector">
        <button v-for="category in ['images', 'documents']" @click="setCategory(category)" :class="{'isActive': activeCategory === category}">{{ $t(`${ category }Category`) }}</button>
      </section>
    
      <MediaAlbumList :category="activeCategory" :key="activeCategory" />
    </div>
  </NuxtLayout>
</template>

<script setup>
  defineOptions({
    auth: 'local',     
  })

  const props = defineProps({
    page: {}
  });
  
  useHead({
    bodyAttrs: {
      class: 'mediaAlbum'
    },
  })

  const activeCategory = ref('images');

  function setCategory(category) {
    activeCategory.value = category;
  }
</script>

<style lang="scss">
  @import url('@/assets/styles/pages/_mediaAlbum.scss');
</style>